import { colord } from "colord";
import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";
import type { SxProps } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { misc } from "app/themes/colors";
import {
  TASK_NEUTRAL_BACKGROUND_COLOR,
  TASK_PRIORITY_COLORS,
  TASK_PRIORITY_MEDIUM,
  TASK_PRIORITY_URGENT,
} from "constants/staff-tasks";
import { differenceInDays, format, startOfDay } from "date-fns";

type DueDateDisplayProps = {
  date: number | string | Date | null | undefined;
  showDate: boolean;
  isComplete: boolean;
  sx?: SxProps;
};
export default function DueDateDisplay({
  date,
  showDate,
  isComplete,
  sx,
}: DueDateDisplayProps) {
  if (!date) return <Box sx={{ width: "70px" }}></Box>;

  const rawDate = new Date(date);
  const dueDate = new Date(rawDate.getUTCFullYear(), rawDate.getUTCMonth(), rawDate.getUTCDate());
  const daysCount = differenceInDays(
    startOfDay(dueDate),
    startOfDay(new Date())
  );

  const isOverdue = daysCount < 0;
  const isToday = daysCount === 0;
  const isTomorrow = daysCount === 1;
  const daysCountDisplay = Math.abs(daysCount);
  const label = showDate
    ? format(dueDate, "EEE MMM dd")
    : isToday
    ? "today"
    : isTomorrow
    ? "tomorrow"
    : `${daysCountDisplay > 99 ? "99+" : daysCountDisplay} day${
        daysCountDisplay === 1 ? "" : "s"
      } ${isOverdue ? "overdue" : "left"}`;

  const backgroundColor = isComplete
    ? grey[300]
    : isOverdue
    ? TASK_PRIORITY_COLORS.getFromCode(TASK_PRIORITY_URGENT)
    : isToday
    ? colord(TASK_PRIORITY_COLORS.getFromCode(TASK_PRIORITY_MEDIUM))
        .alpha(0.3)
        .saturate(0.1)
        .toHex()
    : TASK_NEUTRAL_BACKGROUND_COLOR;

  //

  return (
    <Tooltip title={`Due Date At: ${format(dueDate, "EEE MMM dd, yyyy")}`}>
      <Typography
        component="div"
        variant="body1"
        sx={{
          boxSizing: "border-box",
          background: backgroundColor,
          borderRadius: "16px",
          px: "3px",
          py: "3px",
          fontWeight: isOverdue && !isComplete ? 700 : 400,
          color: isComplete
            ? grey[900]
            : isOverdue
            ? "white"
            : misc.blackAsphalt,
          fontSize: "14px",
          lineHeight: "18px",
          textAlign: "center",
          width: "120px",
          ...sx,
        }}
      >
        {label}
      </Typography>
    </Tooltip>
  );
}
